import './Links.scss'

function Back() {
  return (
    <>
      <div className="screen-end-links">
        <span className="back">Back</span>
      </div>
    </>
  );
}

export default Back;